/* ─────────────────────────────────────────────────────────────────
   Audit fixes — JS-only items from the Parts-audit walk-through.
   Every module is defensive: it does nothing if its target isn't on
   the current page, so this script can safely load on every page.
   ───────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  /* ── p.123 · Phone-number field validation ─────────────────────
     Auditor: "You can enter any value / any number of digits in the
     phone number entry field." Add:
       - inputmode=tel and pattern=[digits/spaces/dashes/parens/plus]
       - length cap at 20 (covers +1 (xxx) xxx-xxxx-ext-xxxx worst case)
       - stripping obvious junk on blur */
  function initPhoneFields() {
    var inputs = document.querySelectorAll('input[type="tel"], input[name*="phone" i], input[name*="tel" i]');
    inputs.forEach(function (input) {
      if (input.dataset.neuPhoneInited === '1') return;
      input.dataset.neuPhoneInited = '1';
      if (!input.hasAttribute('inputmode')) input.setAttribute('inputmode', 'tel');
      if (!input.hasAttribute('pattern')) input.setAttribute('pattern', '[0-9+()\\-\\s]{7,20}');
      if (!input.hasAttribute('maxlength')) input.setAttribute('maxlength', '20');
      input.setAttribute('autocomplete', input.getAttribute('autocomplete') || 'tel');
      input.addEventListener('blur', function () {
        /* Strip anything that isn't a digit, +, (, ), -, or space. */
        var cleaned = input.value.replace(/[^0-9+()\-\s]/g, '');
        if (cleaned !== input.value) input.value = cleaned;
      });
    });
  }

  /* ── p.121 · Better validation error surfaces ──────────────────
     Native constraint validation kicks in on submit. Turn the browser
     bubbles into inline messages: when invalid, render a small span
     beneath the field with the browser's own validationMessage. */
  function initFormValidationCopy() {
    var forms = document.querySelectorAll('form:not([data-neu-novalidate])');
    forms.forEach(function (form) {
      if (form.dataset.neuValidateInited === '1') return;
      form.dataset.neuValidateInited = '1';

      form.addEventListener('invalid', function (e) {
        var el = e.target;
        if (!el || !el.matches('input, select, textarea')) return;
        showFieldError(el);
      }, true);

      form.querySelectorAll('input, select, textarea').forEach(function (el) {
        el.addEventListener('input', function () {
          if (el.validity.valid) clearFieldError(el);
        });
        el.addEventListener('blur', function () {
          if (!el.validity.valid && el.value !== '') showFieldError(el);
        });
      });
    });

    function showFieldError(el) {
      clearFieldError(el);
      var msg = document.createElement('span');
      msg.className = 'neu-field-error';
      msg.setAttribute('data-neu-field-error', '');
      msg.setAttribute('role', 'alert');
      msg.textContent = el.validationMessage || 'Please check this field.';
      msg.style.cssText = 'display:block;color:#b23a3a;font-size:12px;line-height:1.4;margin-top:4px;';
      var host = el.closest('.field, .form__field, .form-field, .form-group') || el.parentElement;
      if (host) host.appendChild(msg);
    }
    function clearFieldError(el) {
      var host = el.closest('.field, .form__field, .form-field, .form-group') || el.parentElement;
      if (!host) return;
      host.querySelectorAll('[data-neu-field-error]').forEach(function (n) { n.remove(); });
    }
  }

  /* ── p.91 · Product-card outbound links open in current tab ────
     Rule: any <a> whose href hostname is not the current site opens
     in a new tab. Skips mailto/tel/javascript. Idempotent. */
  function initOutboundLinks() {
    var host = location.hostname;
    document.querySelectorAll('a[href^="http"]').forEach(function (a) {
      if (a.dataset.neuOutboundInited === '1') return;
      try {
        var u = new URL(a.href);
        if (u.hostname === host) return;
        if (u.hostname.endsWith('neuapplianceparts.com')) return;
        if (u.hostname.endsWith('.myshopify.com')) return;
      } catch (e) { return; }
      a.dataset.neuOutboundInited = '1';
      a.setAttribute('target', '_blank');
      var rel = (a.getAttribute('rel') || '').split(/\s+/);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
      a.setAttribute('rel', rel.join(' ').trim());
    });
  }

  /* Boot */
  function boot() {
    initPhoneFields();
    initFormValidationCopy();
    initOutboundLinks();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Re-run when Shopify re-renders sections (cart drawer, variant
     change, etc). */
  document.addEventListener('shopify:section:load', boot);
})();
